<div class="time-picker-wrapper">
  @if (!hideLabel && label) {
    <label class="time-picker-label">
      @if (isRequired){
        <span  class="required-mark">*</span>
      }
      {{ label | localization }}
    </label>
  }

  <div class="time-picker-input-wrapper" (click)="onOpenModal()">
    <input
      type="text"
      [value]="displayValue"
      [placeholder]="placeholder | localization"
      [disabled]="disabled"
      class="time-picker-input"
      readonly
    >

    @if (displayValue) {
      <button
        type="button"
        class="time-picker-clear"
        (click)="onDelete($event)"
        [disabled]="disabled"
      >
        <ui-icon name="close" size="18px" color="#868686"></ui-icon>
      </button>
    } @else {
      <span class="time-picker-icon">
        <ui-icon name="clock-circle" color="#868686"></ui-icon>
      </span>
    }
  </div>

  @if (control?.invalid && control?.touched && !hideError) {
    <div class="error-message">
      {{ errorTip | localization}}
    </div>
  }
</div>
